import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface RecurringTooltipProps {
  openLeft: boolean
  isBudget?: boolean
  className?: string
}

const RecurringTooltip: React.FC<RecurringTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip openLeft={props.openLeft} className={props.className}>
      <p>
        {!props.isBudget &&
          translate(
            '${recurringVCs} reset spending limits at your desired frequency and can be updated or turned off at any time. When a virtual card resets, your spent amount will return to $0. Previous activity can still be seen in the card’s transaction history.',
            {
              recurringVCs: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  {translate('Recurring virtual cards')}
                </span>
              ),
            },
          )}
        {props.isBudget &&
          translate(
            '${recurringBudgets} reset to their original spending limits at your desired frequency and can be updated or turned off at any time. When a budget resets, your spent amount will return to $0. Previous activity can still be seen in the transaction history.',
            {
              recurringBudgets: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  {translate('Recurring budgets')}
                </span>
              ),
            },
          )}
      </p>
    </Tooltip>
  )
}

export default RecurringTooltip
